import { useNavigate } from 'react-router-dom';
import { SparkIcon } from './Icons';
import { STAFF_ASSISTANT_NAME } from '@/lib/assistant';

// Ask, the staff assistant, from every main screen's header (Gary, 3 Nov 2026): the AI sparkle in CleanMyBed violet,
// with the word Ask whenever there is room, as in Sentinel. The round "+" above the tab bar is New chat.
export function AskButton() {
  const navigate = useNavigate();
  const label = `Ask ${STAFF_ASSISTANT_NAME}`;
  return (
    <button type="button" className="chats-listhead-help chats-ask-btn" aria-label={label} title={label} onClick={() => navigate('/drc')}>
      <SparkIcon /><span className="chats-ask-btn-word">Ask</span>
    </button>
  );
}
